var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "rankPage page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg-1.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "head__label"
  }, [_vm._v(_vm._s(_vm.$lang('Prize Pool')))]), _c('div', {
    staticClass: "head__num"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "alt": "",
      "height": "26"
    }
  }), _vm._v(" " + _vm._s(_vm.poolInfo.total_keys) + "   +   "), _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/tap.png`),
      "alt": "",
      "width": "26"
    }
  }), _vm._v(" " + _vm._s(_vm.poolInfo.total_taps) + " ")]), _c('div', {
    staticClass: "head__tip"
  }, [_vm._v(" " + _vm._s(_vm.$lang('Please note that the ranking data may be delayed. Please refer to the final results for accuracy.')) + " ")])]), _vm.rankList.length > 0 ? _c('div', {
    staticClass: "list"
  }, [_vm._l(_vm.rankList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-icon"
    }, [index === 0 ? _c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/rank-1.png`),
        "alt": ""
      }
    }) : index === 1 ? _c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/rank-2.png`),
        "alt": ""
      }
    }) : index === 2 ? _c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/rank-3.png`),
        "alt": ""
      }
    }) : _c('span', [_vm._v(_vm._s(index + 1))])]), _c('m-head', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    }), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item__label"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
      staticClass: "item__num"
    }, [_c('div', [_vm._v(" " + _vm._s(_vm.$lang('Score:')) + " " + _vm._s(item.score) + " ")]), _c('div', {
      staticClass: "num"
    }, [item.reward_keys > 0 ? [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/earn-key.png`),
        "alt": "",
        "height": "18"
      }
    }), _vm._v(" " + _vm._s(item.reward_keys) + " + ")] : _vm._e(), item.reward_taps > 0 ? [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/tap.png`),
        "alt": "",
        "width": "18"
      }
    }), _vm._v(" " + _vm._s(item.reward_taps) + " ")] : _vm._e()], 2)])])], 1);
  }), _vm.userRankInfo ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_vm.userRankInfo.rank === 1 ? _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/rank-1.png`),
      "alt": ""
    }
  }) : _vm.userRankInfo.rank === 2 ? _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/rank-2.png`),
      "alt": ""
    }
  }) : _vm.userRankInfo.rank === 3 ? _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/rank-3.png`),
      "alt": ""
    }
  }) : _vm.userRankInfo.rank <= 100 ? _c('span', [_vm._v(_vm._s(_vm.userRankInfo.rank))]) : _c('span', [_vm._v("100+")])]), _c('m-head', {
    attrs: {
      "name": _vm.userRankInfo,
      "bgColor": _vm.userRankInfo.head_color
    }
  }), _c('div', {
    staticClass: "item-info"
  }, [_c('div', {
    staticClass: "item__label"
  }, [_vm._v(_vm._s(_vm.userRankInfo.firstname) + " " + _vm._s(_vm.userRankInfo.lastname))]), _c('div', {
    staticClass: "item__num"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.$lang('Score:')) + " " + _vm._s(_vm.userRankInfo.score || 0) + " ")]), _c('div', {
    staticClass: "num"
  }, [_vm.userRankInfo.reward_keys > 0 ? [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "alt": "",
      "height": "18"
    }
  }), _vm._v(" " + _vm._s(_vm.userRankInfo.reward_keys) + " + ")] : _vm._e(), _vm.userRankInfo.reward_taps > 0 ? [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/tap.png`),
      "alt": "",
      "width": "18"
    }
  }), _vm._v(" " + _vm._s(_vm.userRankInfo.reward_taps) + " ")] : _vm._e()], 2)])])], 1) : _vm._e()], 2) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };